import React, { Fragment, useState } from 'react';


const EditWorker = ({ this_worker, refresh_workers }) => {

    const [worker_id, setWorker_id] = useState(this_worker.worker_id)
    const [worker_name, setWorker_name] = useState(this_worker.worker_name)
    const [worker_email, setWorker_email] = useState(this_worker.worker_email)
    const [worker_active, setWorker_active] = useState(this_worker.worker_active)
    const [worker_is_admin, setWorker_is_admin] = useState(this_worker.is_admin >= 1)


    const [success, setSuccess] = useState(false);
    const [failure, setFailure] = useState(false);


    const reset = async (e) => {
        setWorker_id(this_worker.worker_id)
        setWorker_name(this_worker.worker_name)
        setWorker_email(this_worker.worker_email)
        setWorker_active(this_worker.worker_active)
        setWorker_is_admin(this_worker.is_admin >= 1)
        setSuccess(false);
        setFailure(false);

    }

    function switchViewer() {
        setWorker_is_admin(!worker_is_admin)
    }

    function switchActive() {
        setWorker_active(!worker_active)
    }

    const onSubmitForm = async (e) => {
        e.preventDefault();

        const body = { worker_id, worker_name, worker_email, worker_active, worker_is_admin }
        await fetch("/workers/update", {
            method: "PUT",
            headers: { "Content-Type": "application/json", token: localStorage.token },
            body: JSON.stringify(body)
        }).then(function (response) {
            if (response.status === 403|| response.status === 409 || response.status === 404) {
                setFailure(true)
                setSuccess(false)
            } else {
                setSuccess(true)
                setFailure(false)
            }
        }).catch(function (response) {
            setFailure(true)
            setSuccess(false)
        })

        refresh_workers()


    }

    const resetWorker = async (e) => {
        e.preventDefault();
        const worker_id = this_worker.worker_id

        var new_password = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
        var charactersLength = characters.length;
        for (var i = 0; i < 10; i++) {
            new_password += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }


        const body = { new_password, worker_id }

        await fetch("/workers/reset_password", {
            method: "PUT",
            headers: { "Content-Type": "application/json", token: localStorage.token },
            body: JSON.stringify(body)
        }).then(function (response) {
            if (response.status === 404) {
                setFailure(true)
                setSuccess(false)
            } else {
                setSuccess(true)
                setFailure(false)
            }
        }).catch(function (response) {
            setFailure(true)
            setSuccess(false)
        })

    }
    return (
        <Fragment>
            <button type="button" className="btn btn-info" data-toggle="modal" data-target={`#id_admin${this_worker.worker_id}`}>
                Edit
            </button>

            <div className="modal fade" id={`id_admin${this_worker.worker_id}`}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Worker Information</h4>
                            <button type="button" className="close" data-dismiss="modal" onClick={() => reset()}>&times;</button>
                        </div>

                        <div className="modal-body">

                            <form onSubmit={onSubmitForm}>
                                <p>Worker ID: {this_worker.worker_id}</p>


                                <input type="text" className="form-control" value={worker_name} onChange={e => setWorker_name(e.target.value)} />
                                <input type="text" className="form-control" value={worker_email} onChange={e => setWorker_email(e.target.value)} />
                                <input placeholder="Viewer" type="checkbox" className="form-check-input ml-2 mt-2" id="make_viewer_check" checked={worker_is_admin} value={worker_is_admin} onChange={switchViewer} />
                                <label className="form-check-label ml-5 mt-1" htmlFor="make_viewer_check">
                                    Viewer
                                </label>

                                <input placeholder="Active" type="checkbox" className="form-check-input ml-2 mt-2" id="make_active" checked={worker_active} value={worker_active} onChange={switchActive} />
                                <label className="form-check-label ml-5 mt-1" htmlFor="make_active">
                                    Active
                                </label>
                                <br />
                                <button type="submit" className="btn btn-success m-1" >Update</button>
                                <button type="button" className="btn btn-warning m-1" onClick={resetWorker}>Reset Worker Password</button>
                                {success && <p className="text-success">It Worked</p>}
                                {failure && <p className="text-danger">Didn't work, try again!</p>}
                            </form>


                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-warning" data-dismiss="modal" onClick={() => reset()}>Close</button>
                        </div>

                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default EditWorker;